import { Injectable } from '@angular/core';
import { DatePipe } from '@angular/common';
import { Observable, throwError } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CrudService } from '.';
import { GenericResponse, Usuario, SaveUsuarioDto, SearchUsuariosRequestDto, SearchUsuariosResponseDto, ChangeUserStateRequestDto, ChangePasswordDto } from "../model/index";
import { SearchUsuarioHistorialRequestDto, SearchUsuarioHistorialResponseDto, ActivateUserRequestDto, BlockUserRequestDto } from "../model/index";

import { SharedFunctions } from '../../../../src/app/shared/shared.functions';

@Injectable({
  providedIn: 'root'
})

export class UsuarioService extends CrudService<Usuario, number, SaveUsuarioDto, SearchUsuariosRequestDto> {

  constructor(protected _http: HttpClient, private datePipe: DatePipe, protected sharedFunctions: SharedFunctions) {
    super(_http,'usuario', sharedFunctions);

  }

  searchHistory(p: SearchUsuarioHistorialRequestDto): Observable<SearchUsuarioHistorialResponseDto> {
    var queryString = this.sharedFunctions.convertToQueryString(p);
    return this._http.get<SearchUsuarioHistorialResponseDto>(this._serviceUrl + '/history/search'+queryString, this.httpOptions);
  }

  getSelf(): Observable<GenericResponse<Usuario>> {
    return this._http.get<GenericResponse<Usuario>>(this._serviceUrl + '/self', this.httpOptions);
  }

  resetPassword(id: number): Observable<GenericResponse<boolean>> {
    return this._http.post<GenericResponse<boolean>>(this._serviceUrl + '/reset-password/'+id, this.httpOptions);
  }

  saveSelf(p: SaveUsuarioDto): Observable<GenericResponse<SaveUsuarioDto>> {
    return this._http.post<GenericResponse<SaveUsuarioDto>>(this._serviceUrl + '/self', p, this.httpOptions);
  }

  deleteSelf(): Observable<GenericResponse<boolean>> {
    return this._http.delete<GenericResponse<boolean>>(this._serviceUrl + '/self', this.httpOptions);
  }

  activateUser(p: ActivateUserRequestDto): Observable<GenericResponse<boolean>> {
    return this._http.post<GenericResponse<boolean>>(this._serviceUrl + '/activate', p, this.httpOptions);
  }

  blockUser(p: BlockUserRequestDto): Observable<GenericResponse<boolean>> {
    return this._http.post<GenericResponse<boolean>>(this._serviceUrl + '/block', p, this.httpOptions);
  }

  approveUser(p: ChangeUserStateRequestDto): Observable<GenericResponse<boolean>> {
    return this._http.post<GenericResponse<boolean>>(this._serviceUrl + '/approve', p, this.httpOptions);
  }

  rejectUser(p: ChangeUserStateRequestDto): Observable<GenericResponse<boolean>> {
    return this._http.post<GenericResponse<boolean>>(this._serviceUrl + '/reject', p, this.httpOptions);
  }

  changeMyPassword(p: ChangePasswordDto): Observable<GenericResponse<ChangePasswordDto>> {
    return this._http.post<GenericResponse<ChangePasswordDto>>(this._serviceUrl + '/change-my-password', p, this.httpOptions);
  }
}